export const WIDTH_XS = 599;
export const WIDTH_SM = 959;
export const WIDTH_MD = 1279;
export const WIDTH_LG = 1919;
export const WIDTH_XL = 5000;
